import "./AdditionalSolutionsSubpages.module.css";
import Header from "@/reusable_sections/Header";
import UnifiedWorkspaces from "./sections/UnifiedWorkspaces";
import OurServices from "./sections/OurServices";
import VanguardiaTecnologicaIa from "./sections/VanguardiaTecnologicaIa";
import MerchantNetwork from "./sections/MerchantNetwork";
import HowItWorksProcess from "./sections/HowItWorksProcess";
import PatioRepairComparison from "./sections/PatioRepairComparison";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function AdditionalSolutionsSubpagesPage() {
  return <div>
      <Header />
      <UnifiedWorkspaces />
      <MerchantNetwork />
      <OurServices />
      <VanguardiaTecnologicaIa />
      <HowItWorksProcess />
      <PatioRepairComparison />
      <ContactUs />
      <Footer />
    </div>;
}